module.exports = __webpack_public_path__ + "static/media/13_temp_fair_ko.d84f883f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/13_temp_fair_ko.png
// module id = 723
// module chunks = 0